import React, { useEffect, useState } from "react";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import LocationOnIcon from "@mui/icons-material/LocationOn"; // Importa los iconos que necesites
import { StyledCard, StyledTextField, StyledSelect } from "./FromStyles";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {
  Button,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Typography,
  Divider,
} from "@mui/material";
import { OutlinedInput } from "@mui/material";
import GooglePlacesAutocomplete from "../../utils/objects/GooglePlacesAutocomplete";
import { Grid } from "@mui/material";
const FromShippingOrigin = ({
  onChange,
  dataOrigin,
  dataDirectory,
  handleDataOrder,
  companyData,
}) => {
  const [showEdit, setShowEdit] = useState(false);
  const [method, setThisMethod] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState("");

  const [origenAdress, setOrigenAdress] = useState({
    clientNamesOrigin: "",
    clientRutOrigin: "",
    userPhoneOrigin: "",
    clientEmailOrigin: "",
    addressOrigin: "",
    direccion1Origin: "",
    direccion2Origin: "",
    direccion3Origin: "N/A",
    communeOrigin: "",
    commune2Origin: "",
    regionOrigin: "",
    countryOrigin: "",
  });
  const [stateDataOrigin, setFormStateDataOrigin] = useState({});

  useEffect(() => {
    handleDataOrder(origenAdress);
  }, [origenAdress]);

  useEffect(() => {
    if (dataOrigin) {
      setFormStateDataOrigin(dataOrigin);
    }
  }, [dataOrigin]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setOrigenAdress((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSelections = (item) => {
    if (item) {
      setOrigenAdress((prevState) => ({
        ...prevState,
        addressOrigin: item.address,
        addressGeoreft: item.addressGeoreft,
        direccion1Origin: item.direccion1,
        direccion2Origin: item.direccion2,
        communeOrigin: item.commune,
        commune2Origin: item.locality,
        regionOrigin: item.region,
        countryOrigin: item.country,
      }));
    }
  };

  const handleChangeMetod = (e) => {
    setThisMethod(e.target.checked);
  };

  const handleSelect = (event) => {
    const value = event.target.value;
    if (value === companyData.id) {
      console.log(companyData);
      setOrigenAdress((prevState) => ({
        ...prevState,
        clientNamesOrigin: companyData.companyName,
        clientRutOrigin: companyData.companyRut,
        userPhoneOrigin: companyData.companyAdressPhone,
        clientEmailOrigin: companyData.companyContacEmail,
        addressOrigin: companyData.companyAddress,
        addressGeoreft: {
          lat: companyData.addressGeoreft.latitude,
          lng: companyData.addressGeoreft.longitude,
        },
        direccion1Origin: companyData.direccion1,
        direccion2Origin: companyData.companyNumAddress,
        communeOrigin: companyData.companyCity,
        commune2Origin: companyData.companyComuna,
        regionOrigin: companyData.companyRegion,
        countryOrigin: companyData.companyCountry,
      }));
      setSelectedAddress(companyData.id);
    } else {
      setSelectedAddress(value);
      const filteredData = dataDirectory.filter((item) => item.id === value);
      setOrigenAdress((prevState) => ({
        ...prevState,
        clientNamesOrigin: filteredData[0].clientNamesOrigin,
        clientRutOrigin: filteredData[0].clientRutOrigin,
        userPhoneOrigin: companyData.companyAdressPhone,
        clientEmailOrigin: companyData.companyContacEmail,
        addressOrigin: filteredData[0].toAddressOrigin,
        addressGeoreft: filteredData[0].addressGeoreft,
        direccion1Origin: filteredData[0].direccion1Origin,
        direccion2Origin: filteredData[0].direccion2Origin,
        communeOrigin: filteredData[0].communeOrigin,
        commune2Origin: filteredData[0].commune2Origin,
        regionOrigin: filteredData[0].regionOrigin,
        countryOrigin: filteredData[0].countryOrigin,
      }));
      setSelectedAddress(filteredData[0].id);
    }
  };

  return (
    <StyledCard elevation={0} variant="outlined">
      <CardHeader
        title="Origen ( Punto A )"
        sx={{
          color: "#fff", // Texto blanco
          borderRadius: "10px 10px 0 0",
          padding: "16px",
        }}
      />
      <CardContent sx={{ padding: "1px" }}>
        <Typography sx={{ color: "#fff" }}>
          {" "}
          {"Direcciones de empresa"}
        </Typography>

        <Grid
          item
          sx={{
            width: {
              xs: "50%",
              sm: "50%",
              md: "50%",
              lg: "50%",
            },
          }}
        >
          <FormControlLabel
            control={
              <Switch
                checked={method}
                onChange={(e) => handleChangeMetod(e)}
                name="seguro"
                color="primary"
              />
            }
            label={
              !method ? (
                <Typography sx={{ color: "#fff" }}>
                  {"Ingrese una direccíon"}
                </Typography>
              ) : (
                <Typography sx={{ color: "#fff" }}>
                  {"Seleccion una direccíon"}
                </Typography>
              )
            }
          />
        </Grid>
        <>
          {method ? (
            <FormControl fullWidth margin="dense">
              <Select
                sx={{
                  backgroundColor: "#fff",
                  ".MuiOutlinedInput-input": {
                    borderRadius: "10px",
                    padding: "10px",
                    fontSize: "1rem",
                    color: "#333",
                  },
                }}
                labelId="Direcciones de empresa"
                id="toAddressDefault"
                value={selectedAddress}
                onChange={handleSelect}
                label=""
                input={
                  <OutlinedInput
                    notched
                    startAdornment={<LocationOnIcon color="secondary" />}
                  />
                }
              >
                {dataDirectory.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.adressName}
                  </MenuItem>
                ))}

                <MenuItem key={companyData.id} value={companyData.id}>
                  {companyData.companyName} (Default)
                </MenuItem>
              </Select>
            </FormControl>
          ) : (
            <>
              {!origenAdress.addressOrigin ? (
                <GooglePlacesAutocomplete
                  adress={origenAdress}
                  handleSelections={handleSelections}
                ></GooglePlacesAutocomplete>
              ) : (
                <StyledTextField
                  InputProps={{
                    startAdornment: <LocationOnIcon color="secondary" />,
                  }}
                  name="addressOrigin"
                  value={origenAdress.addressOrigin}
                  onChange={handleChange}
                  placeholder="Autocomplete"
                  fullWidth
                  margin="normal"
                />
              )}
            </>
          )}
        </>

        <Divider></Divider>
      </CardContent>

      <Button onClick={() => setShowEdit(!showEdit)} sx={{ color: "#FFF" }}>
        {" "}
        <EditOutlinedIcon> </EditOutlinedIcon>
        {!showEdit ? "Editar" : "Cerrar editor"}{" "}
      </Button>
      {!showEdit ? (
        <CardContent
          sx={{
            padding: "1px",
            backgroundColor: "#fff",
            padding: "15px",
            borderRadius: "15px",
          }}
        >
          <Typography>Nombre: {origenAdress.clientNamesOrigin} </Typography>
          <Typography>Teléfono: {origenAdress.userPhoneOrigin}</Typography>
          <Typography>RUT:{origenAdress.clientRutOrigin} </Typography>
          <Typography>email:{origenAdress.clientEmailOrigin} </Typography>
          <Divider></Divider>
          <Typography>Calle: {origenAdress.addressOrigin} </Typography>
          <Typography>Número: {origenAdress.direccion2Origin}</Typography>
          <Typography>Ofic / Dpto:{origenAdress.direccion3Origin} </Typography>
          <Typography>Comuna: {origenAdress.commune2Origin}</Typography>
          <Typography>Ciudad:{origenAdress.communeOrigin} </Typography>
          <Typography>Región:{origenAdress.regionOrigin} </Typography>
          <Typography>País:{origenAdress.countryOrigin} </Typography>
        </CardContent>
      ) : (
        <CardContent>
          <StyledTextField
            name="clientNamesOrigin"
            value={origenAdress.clientNamesOrigin}
            onChange={handleChange}
            placeholder="Nombre"
            fullWidth
            margin="normal"
            sx={{ marginTop: "1px", marginBottom: "1px" }}
          />
          <StyledTextField
            name="userPhoneOrigin"
            value={origenAdress.userPhoneOrigin}
            onChange={handleChange}
            placeholder="Teléfono"
            fullWidth
            margin="normal"
            sx={{ marginTop: "1px", marginBottom: "1px" }}
          />
          <StyledTextField
            name="clientRutOrigin"
            value={origenAdress.clientRutOrigin}
            onChange={handleChange}
            placeholder="RUT"
            fullWidth
            margin="normal"
            sx={{ marginTop: "1px", marginBottom: "1px" }}
          />
          <StyledTextField
            name="clientEmailOrigin"
            value={origenAdress.clientEmailOrigin}
            onChange={handleChange}
            placeholder="Correo Electrónico"
            fullWidth
            margin="normal"
            sx={{ marginTop: "1px", marginBottom: "1px" }}
          />

          <StyledTextField
            name="addressOrigin"
            value={origenAdress.addressOrigin}
            onChange={handleChange}
            placeholder="Calle"
            fullWidth
            margin="normal"
            sx={{ marginTop: "1px", marginBottom: "1px" }}
          />
          <StyledTextField
            name="direccion2Origin"
            value={origenAdress.direccion2Origin}
            onChange={handleChange}
            placeholder="Número Calle"
            fullWidth
            margin="normal"
            sx={{ marginTop: "1px", marginBottom: "1px" }}
          />
          <StyledTextField
            name="direccion3Origin"
            value={origenAdress.direccion3Origin}
            onChange={handleChange}
            placeholder="Casa Oficina Departamento"
            fullWidth
            margin="normal"
            sx={{ marginTop: "1px", marginBottom: "1px" }}
          />
          <StyledTextField
            name="commune2Origin"
            value={origenAdress.commune2Origin}
            onChange={handleChange}
            placeholder="Comuna"
            fullWidth
            margin="normal"
            sx={{ marginTop: "1px", marginBottom: "1px" }}
          />
          <StyledTextField
            name="communeOrigin"
            value={origenAdress.communeOrigin}
            onChange={handleChange}
            placeholder="Ciudad"
            fullWidth
            margin="normal"
            sx={{ marginTop: "1px", marginBottom: "1px" }}
          />
          <StyledTextField
            name="regionOrigin"
            value={origenAdress.regionOrigin}
            onChange={handleChange}
            placeholder="Región"
            fullWidth
            margin="normal"
            sx={{ marginTop: "1px", marginBottom: "1px" }}
          />
          <StyledTextField
            name="countryOrigin"
            value={origenAdress.countryOrigin}
            onChange={handleChange}
            placeholder="País"
            fullWidth
            margin="normal"
            sx={{ marginTop: "1px", marginBottom: "1px" }}
          />
        </CardContent>
      )}
    </StyledCard>
  );
};

export default FromShippingOrigin;
